import React from 'react'
import GlobalDialog from './GlobalDialog'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import { ApproveButton, CancelButton, DeleteButton } from '../Buttons/Buttons'

export default function GlobalApproval({
  api,
  loading,
  title,
  displayNote,
  upDateCall,
  buttonName,
  otherActions,
  disabled,
  updatePaginationCall,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <GlobalDialog
        title={title ? title : 'Action'}
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth={'xs'}
        popupButton={
          <ApproveButton
            disabled={disabled}
            size="small"
            action={() => {
              setOpen(true)
            }}>
            {buttonName?buttonName:'Approve'}
          </ApproveButton>
        }
        content={
          <>
            <Typography>{displayNote ?displayNote :"Are you sure you want to proceed with this action?"}</Typography>
          </>
        }
        actionButton={
          <>
            <CancelButton
              action={() => {
                setOpen(false)
              }}>
              Cancel
            </CancelButton>
            <ApproveButton
              action={() => {
                dispatch(api).then((res) => {
                  if (res.payload.status === 'failed' || res.payload.status === 'error') {
                    setOpen(false)
                    enqueueSnackbar(res.payload.message, {
                      variant: 'error',
                    })
                  } else if (res.payload.status === 'success') {
                    dispatch(upDateCall)
                    if (otherActions) {
                        otherActions(false);
                      }
                    if (updatePaginationCall) {
                      dispatch(updatePaginationCall)
                    }
                    setOpen(false)
                    // otherActions(false);
                    enqueueSnackbar(res.payload.message, {
                      variant: 'success',
                    })
                  }
                })
              }}>
              {loading ? "Submitting..." : buttonName?buttonName:'Approve'}
            </ApproveButton>
          </>
        }
      />
    </div>
  )
}
